import Experience from "../Experience.js";
import JSZip from "jszip";
import $ from "jquery";

export default class SaveRoom {
  constructor(
    _shape,
    _measureWalls,
    _objectsScene,
    _texturesWalls,
    _textureFloor
  ) {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.objectManager = this.experience.objectManager;
    this.room = this.experience.room;

    this.tabKeyScreen = [];

    this.shape = _shape;
    this.measureWalls = _measureWalls;
    this.objectsScene = _objectsScene;
    this.texturesWalls = _texturesWalls;
    this.textureFloor = _textureFloor;
  }

  /**
   * Save screenshot in tab
   */
  saveScreenInTab(imageData) {
    this.tabKeyScreen.push(imageData);
  }

  /**
   * Set shape & measures walls
   */
  setDataRoom(measuresWalls, shape) {
    this.shape = shape;
    this.measureWalls = measuresWalls;
  }

  /**
   * Set texture floor
   */
  setTextureFloor(textureFloor) {
    this.textureFloor = textureFloor;
  }

  /**
   * Set texture walls
   */
  setTexturesWalls(texturesWalls) {
    this.texturesWalls = texturesWalls;
  }

  /**
   * Create zip
   */
  /*createZipWithScreenshots() {
    const zip = new JSZip();

    // Add screenshots to the ZIP
    this.tabKeyScreen.forEach((imageData, index) => {
      const base64Data = imageData.split(",")[1]; // Remove "data:image/png;base64,"
      zip.file(`screenshot_${index + 1}.png`, base64Data, { base64: true });
    });

    // Generate the JSON content
    const exportFile = {
      nameConfiguration: "test",
      room: { shape: this.shape, measures: this.measureWalls },
      objects: this.objectsScene,
      texturesWalls: this.texturesWalls,
      textureFloor: this.textureFloor,
    };

    const jsonString = JSON.stringify(exportFile, null, 2);

    // Add JSON file to the ZIP
    zip.file("configuration.json", jsonString);

    return zip;

    // Generate the ZIP file and prompt download
    /* zip.generateAsync({ type: "blob" }).then((content) => {
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(content);
      downloadLink.download = "screenshots_and_configuration.zip";
      downloadLink.click();

      URL.revokeObjectURL(downloadLink.href);
      
    }); 
  }*/

  createZipWithScreenshots() {
    return new Promise((resolve) => {
      const zip = new JSZip();

      this.tabKeyScreen.forEach((imageData, index) => {
        const base64Data = imageData.split(",")[1];
        zip.file(`screenshot_${index + 1}.png`, base64Data, { base64: true });
      });

      const exportFile = {
        nameConfiguration: "test",
        room: { shape: this.shape, measures: this.measureWalls },
        objects: this.objectManager.getSaveInfosObjects(), // this.objectsScene : mettre que ref objets + position
        texturesWalls: this.texturesWalls,
        textureFloor: this.textureFloor,
      };

      const jsonString = JSON.stringify(exportFile, null, 2);
      zip.file("configuration.json", jsonString);

      zip.generateAsync({ type: "blob" }).then((content) => {
        resolve(content);
      });

      zip.generateAsync({ type: "blob" }).then((content) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(content);
        downloadLink.download = "screenshots_and_configuration.zip";
        downloadLink.click();

        URL.revokeObjectURL(downloadLink.href);
      });
    });
  }

  /**
   * Download screenshots and config (no zip)
   */
  async downloadScreenshotsAndConfig() {
    // Créer un tableau de promesses pour tous les téléchargements
    const downloadPromises = this.tabKeyScreen.map(async (imageData, index) => {
      const base64Data = imageData.split(",")[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" });
      
      // Créer une promesse pour ce téléchargement
      return new Promise(resolve => {
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = `screenshot_${index + 1}.png`;
        document.body.appendChild(downloadLink);
        
        // Résoudre la promesse après un délai court
        setTimeout(() => {
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(downloadLink.href);
          resolve();
        }, 100);
      });
    });
    
    // Télécharger le fichier JSON
    const jsonPromise = new Promise(resolve => {
      const exportFile = {
        nameConfiguration: "test",
        room: { shape: this.shape, measures: this.measureWalls },
        objects: this.objectManager.getSaveInfosObjects(),
        texturesWalls: this.texturesWalls,
        textureFloor: this.textureFloor,
      };
      const jsonString = JSON.stringify(exportFile, null, 2);
      const jsonBlob = new Blob([jsonString], { type: "application/json" });
      
      const jsonDownloadLink = document.createElement("a");
      jsonDownloadLink.href = URL.createObjectURL(jsonBlob);
      jsonDownloadLink.download = "configuration.json";
      document.body.appendChild(jsonDownloadLink);
      
      setTimeout(() => {
        jsonDownloadLink.click();
        document.body.removeChild(jsonDownloadLink);
        URL.revokeObjectURL(jsonDownloadLink.href);
        resolve();
      }, 100);
    });
    
    // Attendre que tous les téléchargements soient terminés
    await Promise.all([...downloadPromises, jsonPromise]);
    
    // Ajouter un délai supplémentaire pour s'assurer que tout est bien terminé
    await new Promise(resolve => setTimeout(resolve, 300));
  }

  /**
   * Export JSON file
   */
  exportJSON() {
    const exportFile = {
      nameConfiguration: $("#project_name").val(),
      room: { shape: this.shape, measures: this.measureWalls },
      objects: this.objectsScene, //this.objectsScene
      texturesWalls: this.texturesWalls,
      textureFloor: this.textureFloor,
    };

    const jsonString = JSON.stringify(exportFile, null, 2);

    const blob = new Blob([jsonString], { type: "application/json" });

    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "configuration.json"; // name file
    downloadLink.click();

    URL.revokeObjectURL(downloadLink.href);
  }

  /**
   * Get today's date
   */
  getTodayDate() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return dd + "_" + mm + "_" + yyyy;
  }


  async handleProjectSave(e) {
    e.preventDefault();
    
    const projectName = $("#project_name").val();
    const email = $("#email").val();
    
    // Préparer FormData pour l'envoi du mail
    const formData = new FormData();
    formData.append("projectName", projectName);
    formData.append("email", email);
    
    // Préparer l'objet de configuration
    const exportFile = {
      nameConfiguration: projectName,
      room: { shape: this.shape, measures: this.measureWalls },
      objects: this.objectManager.getSaveInfosObjects(),
      texturesWalls: this.texturesWalls,
      textureFloor: this.textureFloor,
    };
    
    // Convertir en JSON
    const jsonString = JSON.stringify(exportFile, null, 2);
    
    // Ajouter à FormData
    const jsonFile = new File([jsonString], "configuration.json", {
      type: "application/json",
    });
    formData.append("fileJson", jsonFile);
    
    // Traiter tous les screenshots
    const downloadTasks = [];
    
    this.tabKeyScreen.forEach((imageData, index) => {
      const base64Data = imageData.split(",")[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" });
      
      // Ajouter au FormData pour l'envoi mail
      formData.append(
        `screenshot_${index + 1}`,
        blob,
        `screenshot_${index + 1}.png`
      );
      
      // Préparer le téléchargement
      const downloadTask = () => {
        return new Promise((resolve) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = `screenshot_${index + 1}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(downloadLink.href);
          resolve();
        });
      };
      
      downloadTasks.push(downloadTask);
    });
    
    // Préparer le téléchargement du JSON
    const downloadJsonTask = () => {
      return new Promise((resolve) => {
        const jsonBlob = new Blob([jsonString], { type: "application/json" });
        const jsonDownloadLink = document.createElement("a");
        jsonDownloadLink.href = URL.createObjectURL(jsonBlob);
        jsonDownloadLink.download = "configuration.json";
        document.body.appendChild(jsonDownloadLink);
        jsonDownloadLink.click();
        document.body.removeChild(jsonDownloadLink);
        URL.revokeObjectURL(jsonDownloadLink.href);
        resolve();
      });
    };
    
    downloadTasks.push(downloadJsonTask);
    
    // IMPORTANT: D'abord envoyer le mail, puis télécharger les fichiers
    try {
      // 1. Envoyer l'email d'abord
      const mailResponse = await new Promise((resolve, reject) => {
        $.ajax({
          type: "POST",
          url: "https://www.independance-royale-outils.fr/php/mail/send_configuration.php",
          data: formData,
          cache: false,
          processData: false,
          contentType: false,
          success: function(data) {
            resolve(data);
          },
          error: function(xhr, status, error) {
            if (error == "") {
              resolve("Success despite error object");
            } else {
              reject(error);
            }
          },
        });
      });
      
      // 2. Puis télécharger les fichiers séquentiellement
      for (const task of downloadTasks) {
        await task();
        // Petit délai entre chaque téléchargement
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      
      $("#modalSaveProjectBody").html(
        "Sauvegarde du projet réussie. <br><br> Vous avez reçu un mail avec les fichiers de votre configuration."
      );
      
    } catch (error) {
      console.error("Erreur:", error);
      $("#modalSaveProjectBody").html(
        "Erreur lors de la sauvegarde et/ou de l'envoi du projet."
      );
    }
  }

  /**
   * Send request ajax to php
   */
  async sendProjectToMail(e) {

    const projectName = $("#project_name").val();
    const email = $("#email").val();
    const formData = new FormData();

    formData.append("projectName", projectName);
    formData.append("email", email);

    // Ajouter chaque screenshot en fichier séparé
    this.tabKeyScreen.forEach((imageData, index) => {
      const base64Data = imageData.split(",")[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" });

      formData.append(
        `screenshot_${index + 1}`,
        blob,
        `screenshot_${index + 1}.png`
      );
    });

    // Ajouter le fichier JSON
    const exportFile = {
      nameConfiguration: projectName,
      room: { shape: this.shape, measures: this.measureWalls },
      objects: this.objectManager.getSaveInfosObjects(),
      texturesWalls: this.texturesWalls,
      textureFloor: this.textureFloor,
    };
    const jsonString = JSON.stringify(exportFile, null, 2);
    const jsonFile = new File([jsonString], "configuration.json", {
      type: "application/json",
    });
    formData.append("fileJson", jsonFile);

    await new Promise((resolve) => setTimeout(resolve, 100));

    // Envoi AJAXf
    $.ajax({
      type: "POST",
      url: "https://www.independance-royale-outils.fr/php/mail/send_configuration.php",
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: function (data) {
        $("#modalSaveProjectBody").html(
          "Sauvegarde du projet réussie. <br><br> Vous avez reçu un mail avec les fichiers de votre configuration."
        );
      },
      error: function (xhr, status, error) {
        if (error == "") {
          $("#modalSaveProjectBody").html(
            "Sauvegarde du projet réussie. <br><br> Vous avez reçu un mail avec les fichiers de votre configuration."
          );
        } else {
          $("#modalSaveProjectBody").html(
            "Erreur lors de la sauvegarde et/ou de l'envoi du projet."
          );
        }
      },
    });
    e.preventDefault();

  }

  /** Function with zip */
  /*
  sendProjectToMail(e) {
    e.preventDefault();

    // Create zip file (Blob) with screenshot and JSON
    this.createZipWithScreenshots().then((fileZip) => {
      const projectName = $("#project_name").val();
      const email = $("#email").val();

      const formData = new FormData();
      formData.append("projectName", projectName);
      formData.append("email", email);
      formData.append(
        "fileZip",
        fileZip,
        `${projectName}-${this.getTodayDate()}.zip`
      );

      // AJAX request
      $.ajax({
        type: "POST",
        url: "https://www.independance-royale-outils.fr/php/mail/send_configuration.php",
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
        success: function (data) {
          $("#modalSaveProjectBody").html(
            "Sauvegarde du projet réussie. <br><br> Vous avez reçu un mail avec les fichiers de votre configuration."
          );
        },
        error: function (xhr, status, error) {
          if (error == "") {
            $("#modalSaveProjectBody").html(
              "Sauvegarde du projet réussie. <br><br> Vous avez reçu un mail avec les fichiers de votre configuration."
            );
          } else {
            $("#modalSaveProjectBody").html(
              "Erreur lors de la sauvegarde et/ou de l'envoi du projet."
            );
          }
        },
      });
    });
  }*/
}
